import { combineReducers } from "redux"
import timesheetListReducer from "./timesheetListReducer"
import timesheetReducer from "./timesheetReducer"
const rootReducer = combineReducers({
  info: timesheetReducer,
  list: timesheetListReducer,
})

export default rootReducer
